import { DCUser } from '@/models/doc-cirrus/DCUser.ts';

export enum DCTaskType {
    PRINT = 'PRINT',
    TRANSCRIBE = 'TRANSCRIBE',
    NEW_PATIENT = 'NEW_PATIENT',
    CHANGE_REQUEST = 'CHANGE_REQUEST',
    NEW_TRANSFER = 'NEW_TRANSFER',
    CANCELED_TRANSFER = 'CANCELED_TRANSFER',
    TEMPLATE = 'TEMPLATE',
    RULE_ENGINE = 'RULE_ENGINE',
    USER = 'USER',
    UNKNOWN = 'UNKNOWN',
}

export enum DCTaskStatus {
    NEW = 'NEW',
    ASSIGNED = 'ASSIGNED',
    DONE = 'DONE',
    UNKNOWN = 'UNKNOWN',
}

export const task_status_de_translation: Record<DCTaskStatus, string> = {
    [DCTaskStatus.NEW]: 'Neu',
    [DCTaskStatus.ASSIGNED]: 'In Bearbeitung',
    [DCTaskStatus.DONE]: 'Erledigt',
    [DCTaskStatus.UNKNOWN]: 'Unbekannt',
};

export enum TaskUrgency {
    LOW = 1,
    NORMAL = 2,
    HIGH = 3,
    VERY_HIGH = 4,
}

export const task_urgency_de_translation: Record<TaskUrgency, string> = {
    1: 'Niedrig',
    2: 'Normal',
    3: 'Hoch',
    4: 'Sehr hoch',
};

export interface DCTask {
    instance_id: string;
    id: string;
    employee_id?: string;
    patient_id?: string;
    schedule_id?: string;
    activity_id?: string;
    patient_partner_id?: string;
    creator_id?: string;

    title: string;
    type: DCTaskType;
    status: DCTaskStatus;

    orig_type: string;
    task_type?: string;
    urgency?: TaskUrgency;
    employee_name?: string;
    patient_name?: string;
    patient_date_of_birth?: string; // enriched by our backend (not present on the raw DC task)
    patient_number?: string; // enriched by our backend (not present on the raw DC task)
    activity_type?: string;

    details?: string;
    is_all_day?: boolean;
    is_group?: boolean;
    is_session_wide?: boolean;
    roles?: string[];
    candidates?: string[];
    locations?: DCTaskLocation[];
    activities?: string[];

    alert_time?: string;
    template_alert_time_absolute?: number;
    template_alert_time_interval?: string;

    sync_state: string; // UPTODATE, OUTDATED, VERIFIED_MISSING

    meta: {
        created_at: string;
        updated_at: string;

        synced_at: string;

        date_created?: string;
        date_done?: string;
    };
}

export interface DCTaskLocation {
    id: string;
    name: string;
}

export interface CreateDCTaskDto {
    employee_id?: string;
    patient_id?: string;
    schedule_id?: string;
    activity_id?: string;
    patient_partner_id?: string;
    creator_id?: string;

    title: string;
    type: DCTaskType;
    status: DCTaskStatus;

    orig_type?: string;
    task_type?: string;
    urgency?: number; // 1-4
    employee_name?: string;
    patient_name?: string;
    activity_type?: string;

    details?: string;
    is_all_day?: boolean;
    is_group?: boolean;
    is_session_wide?: boolean;
    roles?: string[];
    candidates?: string[];
    locations?: DCTaskLocation[];
    activities?: string[];

    alert_time?: string;
    template_alert_time_absolute?: number;
    template_alert_time_interval?: string;
}

// TODO: to be expanded
export type UpdateDCTaskDto = Partial<
    Pick<
        CreateDCTaskDto,
        | 'title'
        | 'status'
        | 'urgency'
        | 'details'
        | 'is_all_day'
        | 'is_group'
        | 'is_session_wide'
        | 'roles'
        | 'candidates'
        | 'locations'
        | 'alert_time'
        | 'patient_id'
        | 'patient_name'
        | 'employee_id'
        | 'employee_name'
        | 'schedule_id'
        | 'activity_id'
    >
>;

export interface EnrichedTask extends DCTask {
    creator?: DCUser;
    type_name?: string;
}
